import React, { useCallback, useState } from 'react';
import { connect, useSelector } from 'react-redux';

import SecondaryMenu from '../../menu/secondaryMenu.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import { environmentSuffixSelector, periodOrCurrentSelector } from '../../shared/store/selectors';
import { displayZeroSelector, hideDecimalsSelector, negativeMinusSelector } from '../../userData/store/selectors';

import DataGrid from './dataGrid.component';

import { Period } from '../shared/types';
import { AppState } from '../../stateType';
import HamburgerDropdown from '../shared/hamburgerDropdown.component';
import { useDiagnosticsQueries } from './useDiagnostics';
import { downloadDiagnosticsXlsx } from './downloadDiagnosticsXlsx';

const useDownloadDiagnosticsXlsx = (periodName: string) => {
  const [xlsxLoading, setXlsxLoading] = useState(false);
  const environmentSuffix = useSelector(environmentSuffixSelector);
  const hideDecimals = useSelector(hideDecimalsSelector);
  const negativeMinus = useSelector(negativeMinusSelector);
  const shouldDisplayZero = useSelector(displayZeroSelector);

  const {
    isLoading,
    data,
  } = useDiagnosticsQueries(periodName, true);

  const downloadXlsx = useCallback(async (hideDropdown: () => void) => {
    setXlsxLoading(true);

    await downloadDiagnosticsXlsx({
      periodName,
      data,
      environmentSuffix,
      hideDecimals,
      negativeMinus,
      shouldDisplayZero,
    });
    hideDropdown();
    setXlsxLoading(false);
  }, [
    data,
    environmentSuffix,
    hideDecimals,
    negativeMinus,
    shouldDisplayZero,
    periodName,
  ]);


  return {
    xlsxLoading,
    isLoading: Object.values(isLoading).some(el => el),
    downloadXlsx,
  };
};

type DiagnosticsPageProps = {
  periods: Period[],
  period: Period,
  selectPeriod: (period: Period) => void,
};
const DiagnosticsPage = ({ period }: DiagnosticsPageProps) => {
  const { isLoading, downloadXlsx } = useDownloadDiagnosticsXlsx(period.name);

  const exportLabel = isLoading ? 'Data not ready' : undefined; // eslint-disable-line no-undefined

  return (
    <div className="configuration-settings-page">
      <SecondaryMenu>
        <div className="aggregation-menu">
          <div className="aggregation-group">
            <PeriodDropdown />
          </div>
          <div className="hamburger-dropdown text-right">
            <HamburgerDropdown
              exportToExcel={downloadXlsx}
              disableExporting={isLoading}
              exportLabel={exportLabel}
            />
          </div>
        </div>
      </SecondaryMenu>
      <div className="page">
        <div className="container-fluid">
          <div className="row no-gutters page-content-container">
            <div className="col">
              <div className="d-flex flex-row justify-content-between">
                <h5>Diagnostics</h5>
              </div>
            </div>
          </div>
          <div className="row no-gutters page-content-container">
            <div className="col">
              <DataGrid periodName={period.name} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  period: periodOrCurrentSelector(state),
});

export default connect(mapStateToProps)(DiagnosticsPage);
